import React, { useEffect, useState, useMemo } from 'react';
/* global axios */
import api from '../services/apiService';
import { useNavigate, useLocation} from 'react-router-dom';
import { Helmet } from 'react-helmet';  // Import von React Helmet
import moment from 'moment';
import Select from 'react-select'; // Neu: react-select importieren
import AsyncSelect from 'react-select/async';




const OrderList = () => {
  // Router-Hooks ganz oben
  const navigate = useNavigate();
  const location = useLocation();
  // URL-Parameter parsen und orderNumber extrahieren
  const urlParams = new URLSearchParams(location.search);
  const urlOrderNumber = urlParams.get('orderNumber');

  // 1) Nummer aus Navigation-State übernehmen (kommt aus OrderForm.navigate('/orders', { state:{focusOrderNumber} }))
useEffect(() => {
  const focus = (location.state?.focusOrderNumber ?? '').toString().trim();
  if (focus) {
    setFilters(prev => ({ ...prev, orderNumber: { value: focus, label: focus }}));
    navigate(location.pathname, { replace: true, state: {} });
  }
}, [location.state, location.pathname, navigate]);

useEffect(() => {
  const s = (urlOrderNumber ?? '').toString().trim();
  if (s) {
    setFilters(prev => ({ ...prev, orderNumber: { value: s, label: s }}));
    navigate(location.pathname, { replace: true });
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); // nur einmal



  // State-Hooks
  const [orders, setOrders] = useState([]);
  const [lsModalMode, setLsModalMode] = useState('ls'); // 'ls' | 'ls2'
  // invoiceStates speichert für jeden Auftrag (orderId) den Status:
  // "none" = keine Rechnung, "partial" = Teilrechnung(en) existieren, "final" = finale Rechnung erstellt
  const [invoiceStates, setInvoiceStates] = useState({});
  const [invoices, setInvoices] = useState([]);
  // ⬇️ NEU: Flag, ob Lexware aktiv ist (lexwareBaseUrl gesetzt)
  const [lexwareEnabled, setLexwareEnabled] = useState(false);
  const [filters, setFilters] = useState(() => {
   const stored = localStorage.getItem('orderListFilters');
   const init = stored
     ? JSON.parse(stored)
     : {
         orderNumber: null,
         referenceNumber: null,
         customer: null,
         contact: null,
         date: null,
         status: null,
       };
   // Wenn eine orderNumber in der URL steht, überschreibe den Default-Filter
   if (urlOrderNumber) {
     init.orderNumber = {
       value: urlOrderNumber,
       label: urlOrderNumber
     };
   }
   return init;
 });

  useEffect(() => {
    localStorage.setItem('orderListFilters', JSON.stringify(filters));
    setCurrentPage(1);
  }, [filters]);

  // Serverseitige Filteroptionen laden
  const [serverFilterOptions, setServerFilterOptions] = useState({
    orderNumbers: [],
    referenceNumbers: [],
    customers: [],
    contacts: [],
    dates: [],
    statuses: [],
    operationLocations: [],
  });
  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const response = await api.get('/orders/filter-options');
        setServerFilterOptions(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Filteroptionen:', error);
      }
    };
    fetchFilterOptions();
  }, []);

  // Pagination-Zustände
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 25;
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkProcessing, setBulkProcessing] = useState(false);
  const pageIds = useMemo(() => orders.map((order) => order.id), [orders]);
  const allPageSelected = pageIds.length > 0 && pageIds.every((id) => selectedIds.includes(id));

  const buildQuery = ({ includePagination = true, page = currentPage } = {}) => {
    const params = new URLSearchParams();

    if (includePagination) {
      params.append('limit', limit);
      params.append('page', page);
    }

    const vOrder = filters.orderNumber?.value?.toString().trim();
    if (vOrder) params.append('orderNumber', vOrder);

    const vRef = filters.referenceNumber?.value?.toString().trim();
    if (vRef) params.append('referenceNumber', vRef);

    const vCust = filters.customer?.value?.toString().trim();
    if (vCust) params.append('customer', vCust);

    const vContact = filters.contact?.value?.toString().trim();
    if (vContact) params.append('contact', vContact);

    const vDate = filters.date?.value?.toString().trim();
    if (vDate) params.append('date', vDate);

    const vStatus = filters.status?.value?.toString().trim();
    if (vStatus) params.append('status', vStatus);

    const vSR = filters.smartRental?.value?.toString().trim();
    if (vSR) params.append('smartRental', vSR);

    const vOpLoc = filters.operationLocation?.value?.toString().trim();
    if (vOpLoc) params.append('operationLocation', vOpLoc);

    const qs = params.toString();
    return qs ? `?${qs}` : '';
  };

  const fetchOrders = async (page = currentPage) => {
    const query = buildQuery({ page });
    console.log('[OrderList] GET /orders/list' + query);
    const response = await api.get(`/orders/list${query}`);
    setOrders(response.data.data);
    setTotalPages(response.data.pages);
  };


  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const query = buildQuery();
        console.log('[OrderList] GET /orders/list' + query); // << hilft beim Verifizieren
        const response = await api.get(`/orders/list${query}`);
        setOrders(response.data.data);
        setTotalPages(response.data.pages);
      } catch (error) {
        console.error("Fehler beim Abrufen der Aufträge:", error);
      }
    };
    fetchOrders();
  }, [filters, currentPage]);
  

// === Neuer Auftrag: Kundenwahl ===
const [showNewOrderModal, setShowNewOrderModal] = useState(false);
const [selectedCustomerOpt, setSelectedCustomerOpt] = useState(null); // {value,label}
const [isCreatingOrder, setIsCreatingOrder] = useState(false);



  // Funktion zur Formatierung von Datumsangaben
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind 0-indexiert
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const handleViewPDF = (orderId) => {
    const pdfUrl = `${api.defaults.baseURL}/documents/order/${orderId}/pdf`;
    window.open(pdfUrl, '_blank');
  };

 

  // Zweiter Effekt: invoiceStates anhand vorhandener Rechnungen initialisieren
  useEffect(() => {
    const initializeInvoiceStates = () => {
      const initialStates = {};
      orders.forEach(order => {
        if (order.invoices && order.invoices.length > 0) {
          const finalExists = order.invoices.some(inv => inv.invoiceType === "finalInvoice");
          initialStates[order.id] = finalExists ? "final" : "partial";
        } else {
          initialStates[order.id] = "none";
        }
      });
      setInvoiceStates(initialStates);
    };

    initializeInvoiceStates();
  }, [orders]);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await api.get("/invoices");
        // Hier sicherstellen, dass invoices immer ein Array ist:
        setInvoices(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Fehler beim Laden der Rechnungen:", error);
      }
    };
  
    fetchInvoices();
  }, []);

  const refreshInvoices = async () => {
    const response = await api.get('/invoices');
    setInvoices(Array.isArray(response.data) ? response.data : []);
  };

  const toggleSelectPage = (checked) => {
    setSelectedIds((prev) =>
      checked
        ? Array.from(new Set([...prev, ...pageIds]))
        : prev.filter((id) => !pageIds.includes(id))
    );
  };

  const toggleSelectOrder = (orderId, checked) => {
    setSelectedIds((prev) =>
      checked
        ? Array.from(new Set([...prev, orderId]))
        : prev.filter((id) => id !== orderId)
    );
  };

  const selectAllFilteredOrders = async () => {
    try {
      const response = await api.get(`/orders/ids${buildQuery({ includePagination: false })}`);
      setSelectedIds(response.data.ids || []);
    } catch (error) {
      console.error('Fehler beim Laden aller Auftrags-IDs:', error);
      alert('Die gefilterten Auftraege konnten nicht geladen werden.');
    }
  };

  const handleBulkFinalInvoiceMail = async () => {
    if (selectedIds.length === 0) {
      alert('Bitte waehlen Sie mindestens einen Auftrag aus.');
      return;
    }

    const confirmed = window.confirm(
      `Fuer ${selectedIds.length} Auftrag${selectedIds.length === 1 ? '' : 'e'} Schlussrechnungen erstellen und direkt mailen?`
    );
    if (!confirmed) {
      return;
    }

    try {
      setBulkProcessing(true);
      const response = await api.post('/orders/bulk/final-invoices/mail', {
        orderIds: selectedIds,
      });

      const { summary, results } = response.data;
      const failedResults = (results || []).filter((result) => !result.mailSent);
      const failureDetails = failedResults.map((result) => {
        const outcome = result.invoiceCreated
          ? `Rechnung ${result.invoiceNumber || result.invoiceId} erstellt, Mailversand fehlgeschlagen`
          : 'Keine Rechnung erstellt';
        return `Auftrag ${result.orderId}: ${outcome}. ${result.error || 'Unbekannter Fehler.'}`;
      });

      alert(
        [
          `Schlussrechnungen erstellt: ${summary?.invoiceCreated ?? 0}`,
          `Mails versendet: ${summary?.mailSent ?? 0}`,
          `Fehlgeschlagen: ${summary?.failed ?? 0}`,
          ...failureDetails,
        ].filter(Boolean).join('\n')
      );

      setSelectedIds([]);
      await Promise.all([fetchOrders(), refreshInvoices()]);
    } catch (error) {
      console.error('Fehler beim Sammelerstellen der Schlussrechnungen:', error);
      alert(error.response?.data?.error || 'Die Sammelaktion konnte nicht ausgefuehrt werden.');
    } finally {
      setBulkProcessing(false);
    }
  };


  useEffect(() => {
  const fetchCompanySetup = async () => {
    try {
      const res = await api.get('/companysetups');
      const list = res.data || [];
      const setup = list[0];

      if (setup && setup.lexwareBaseUrl && setup.lexwareBaseUrl.trim() !== '') {
        setLexwareEnabled(true);
      } else {
        setLexwareEnabled(false);
      }
    } catch (err) {
      console.error('Fehler beim Laden von CompanySetup:', err);
      setLexwareEnabled(false);
    }
  };

  fetchCompanySetup();
}, []);


  // Auftrag löschen
  const deleteOrder = (id) => {
    if (window.confirm('Möchten Sie diesen Auftrag wirklich löschen?')) {
      api.delete(`/orders/${id}`)
        .then(() => {
          setOrders(prev => prev.filter(order => order.id !== id));
          alert('Auftrag erfolgreich gelöscht!');
        })
        .catch(error => console.error('Fehler beim Löschen des Auftrags:', error));
    }
  };

 // Draft-Auftrag mit gewählter customerId anlegen
const createDraftOrder = async (customerId) => {
  try {
    const payload = { customerId };
    const response = await api.post('/orders/draft', payload);
    const { editUrl } = response.data;
    navigate(editUrl);
  } catch (error) {
    console.error('Fehler beim Erstellen eines Auftragsentwurfs:', error);
    alert('Fehler beim Erstellen des Auftragsentwurfs!');
  }
};


  // Funktion zum Duplizieren eines Auftrags in eine Rechnung
  // Falls invoiceType "downPayment" ist, wird der Nutzer nach der Höhe des Netto-Abschlags gefragt.
  const createInvoice = async (orderId, invoiceType) => {
    try {
      const payload = { invoiceType };
  
      if (invoiceType === "downPayment") {
        // 1. Abfrage des Netto-Abschlagsbetrags
        const input = window.prompt("Bitte geben Sie den Netto-Abschlagsbetrag ein:");
        if (input === null) {
          alert("Rechnungserstellung abgebrochen: Kein Abschlagsbetrag eingegeben.");
          return; // Abbruch, falls der Nutzer hier abbricht
        }
        const netDownPayment = parseFloat(input);
        if (isNaN(netDownPayment) || netDownPayment <= 0) {
          alert("Bitte geben Sie eine gültige Zahl größer als 0 ein.");
          return;
        }
        payload.netDownPayment = netDownPayment;
  
        // 2. Abfrage des Datums "Billed Until" im deutschen Format
        const billedUntilInput = window.prompt("Bitte geben Sie das Datum ein, bis wann die Leistung abgerechnet wird (TT.MM.JJJJ):");
        if (billedUntilInput === null || billedUntilInput.trim() === "") {
          alert("Rechnungserstellung abgebrochen: Kein Abrechnungsdatum eingegeben.");
          return; // Abbruch, falls der Nutzer den Prompt abbricht oder keinen Wert eingibt
        }
        const billedUntilFormatted = moment(billedUntilInput, "DD.MM.YYYY").format("YYYY-MM-DD");
        payload.billedUntil = billedUntilFormatted;
  
        // 3. Abfrage für Notizen (optional)
        const noteInput = window.prompt("Bitte geben Sie eine Notiz für die Rechnung ein:");
      if (noteInput === null || noteInput.trim() === "") {
        alert("Rechnungserstellung abgebrochen: Keine Notiz eingegeben.");
        return;
      }
      payload.notes = noteInput;
    }
  
      // Führe den API-Call nur aus, wenn alle erforderlichen Daten vorhanden sind
      const response = await api.post(`/invoices/duplicate/${orderId}`, payload);
      alert(`Rechnung erfolgreich erstellt! Rechnung ID: ${response.data.id}`);
  
      // Aktualisiere den lokalen Order-State mit der neu erstellten Rechnung
      setOrders(prevOrders =>
        prevOrders.map(order => {
          if (order.id === orderId) {
            const newInvoices = order.invoices ? [...order.invoices, response.data] : [response.data];
            return { ...order, invoices: newInvoices };
          }
          return order;
        })
      );
  
      // Aktualisiere den invoiceStates-Zustand
      setInvoiceStates(prevState => ({
        ...prevState,
        [orderId]:
          invoiceType === "finalInvoice"
            ? "final"
            : prevState[orderId] === "final"
            ? "final"
            : "partial"
      }));
    } catch (error) {
      console.error(`Fehler beim Erstellen der ${invoiceType}-Rechnung:`, error);
      alert(`Fehler beim Erstellen der ${invoiceType}-Rechnung!`);
    }
  };
  

  // Hilfsfunktion: Rechnung an den Besteller mailen
  const sendOrderMail = async (orderId) => {
    try {
      await api.post(`/documents/order/${orderId}/mail`);
      alert('✅ Auftrag erfolgreich gemailt!');
    } catch (error) {
      console.error('Fehler beim Mailen des Auftrags:', error);
      alert('Fehler beim Mailen des Auftrags!');
    }
  };

 // Handler für Zwischenabrechnung
const handleInterim = async (orderId) => {
  try {
    const response = await api.post(`/interims/duplicate/${orderId}`);
    alert(`Zwischenabrechnung erstellt! Nummer: ${response.data.interimNumber}`);
    // hier ggf. State-Update für die Order-Liste
  } catch (err) {
    // Falls das Backend eine spezifische Fehlermeldung liefert
    if (err.response && err.response.data && err.response.data.error) {
      alert(err.response.data.error); // Zeige die Backend-Meldung
    } else {
      alert("Fehler beim Erstellen der Zwischenabrechnung!");
    }
    console.error(err);
  }
};

const handleDuplicate = async (orderId) => {
  if (!window.confirm("Diesen Auftrag duplizieren und als Entwurf speichern?")) return;

  try {
    const response = await api.post(`/orders/${orderId}/duplicate`);
    if (response.data && response.data.orderId) {
      alert('✅ Auftrag wurde erfolgreich dupliziert!');
      navigate(response.data.editUrl);
    } else {
      alert('Fehler: Auftrag konnte nicht dupliziert werden.');
    }
  } catch (error) {
    console.error('Fehler beim Duplizieren des Auftrags:', error);
    alert('Fehler beim Duplizieren des Auftrags!');
  }
};

// Handler: Auftrag nach Lexware übertragen
const handleLexwareSync = async (orderId) => {
  if (!window.confirm("Diesen Auftrag nach Lexware übertragen?")) return;

  try {
    const res = await api.post(`/lexware/orders/${orderId}/sync`);
    const data = res.data || {};

    if (data.ok) {
      // syncOrderToLexware gibt { mapping, lexwareResponse } zurück,
      // die Route packt das unter "mapping" – also leicht verschachtelt:
      const innerMapping = data.mapping?.mapping || data.mapping;
      const voucherNumber = innerMapping?.voucherNumber;
      const lexwareOrderId = innerMapping?.lexwareOrderId;

      let msg = '✅ Auftrag erfolgreich nach Lexware übertragen.';
      if (voucherNumber) msg += ` Belegnummer: ${voucherNumber}.`;
      else if (lexwareOrderId) msg += ` Lexware-ID: ${lexwareOrderId}.`;

      alert(msg);
    } else {
      // Backend hat zwar 200 geantwortet, aber ok=false gesetzt
      let msg = 'Unbekannter Fehler';

      if (data.code === 'NO_LEXWARE_CONTACT') {
        msg = 'Dieser Kunde ist noch nicht mit Lexware verknüpft.\n' +
              'Bitte zuerst den Kunden nach Lexware synchronisieren und danach den Auftrag senden.';
      } else if (data.message) {
        msg = data.message;
      } else if (data.error) {
        msg = data.error;
      }

      alert(`Fehler beim Lexware-Sync: ${msg}`);
    }
  } catch (err) {
    console.error('Lexware-Order-Sync Fehler:', err);

    const resp = err.response;
    let msg = 'Unbekannter Fehler beim Lexware-Sync.';

    if (resp?.data?.code === 'NO_LEXWARE_CONTACT') {
      msg = 'Dieser Kunde ist noch nicht mit Lexware verknüpft.\n' +
            'Bitte zuerst den Kunden nach Lexware synchronisieren und danach den Auftrag senden.';
    } else if (resp?.status === 429) {
      msg = 'Lexware-Rate-Limit erreicht. Bitte in ein paar Minuten erneut versuchen.';
    } else if (resp?.data?.message) {
      msg = resp.data.message;
    } else if (resp?.data?.error) {
      msg = resp.data.error;
    } else if (err.message) {
      msg = err.message;
    }

    alert(`Fehler beim Lexware-Sync: ${msg}`);
  }
};


// --- Lieferschein (Modal + Auswahl) ---
const [lsModalOpenFor, setLsModalOpenFor] = useState(null); // orderId oder null
const [lsOptions, setLsOptions] = useState([]);              // [{value,label}]
const [lsSelected, setLsSelected] = useState([]);            // Auswahl


// PDF-Öffnen mit optionalen OrderItem-IDs und perDevice
const handleViewDeliveryNote = (orderId, orderItemIds = [], perDevice = false) => {
  const base = `${api.defaults.baseURL}/documents/delivery-note/${orderId}/pdf`;
  const params = new URLSearchParams();

  if (orderItemIds.length) params.set('itemIds', orderItemIds.join(','));
  if (orderItemIds.length) params.set('itemIds', orderItemIds.join(','));
 params.set('perDevice', 'true'); // ⇐ HIER einschalten

  const url = params.toString() ? `${base}?${params.toString()}` : base;
  window.open(url, '_blank');
};

const handleViewDeliveryNote2 = (orderId, orderItemIds = [], perDevice = false) => {
  const base = `${api.defaults.baseURL}/documents/delivery-note2/${orderId}/pdf`;
  const parts = [];
  if (orderItemIds.length) parts.push(`itemIds=${orderItemIds.join(',')}`);
  if (perDevice) parts.push(`perDevice=true`);
  const url = parts.length ? `${base}?${parts.join('&')}` : base;
  window.open(url, '_blank');
};

// Modal öffnen: OrderItems laden, Versicherungen raus, Optionen bauen
const openLsModal = async (orderId, mode = 'ls') => {
  setLsModalMode(mode);             // <-- Mode direkt setzen
  try {
    const { data } = await api.get(`/orders/${orderId}`);
    const orderItems = (data.orderItems || []).filter(oi => {
      const t = oi.item?.itemType;
      return t !== 'insurance' && t !== 'insuranceFixed';
    });

    const opts = orderItems.map(oi => ({
      value: oi.id,
      label: `${oi.item?.name || 'Artikel'} — ${(oi.description || oi.item?.description || '').trim()} (${oi.quantity} ${oi.unit?.name || ''})`
    }));

    setLsOptions(opts);
    setLsSelected(opts);
    setLsModalOpenFor(orderId);
  } catch (e) {
    console.error('Fehler beim Laden der OrderItems:', e);
    alert('Konnte Positionen nicht laden.');
  }
};

const closeLsModal = () => {
  setLsModalOpenFor(null);
  setLsOptions([]);
  setLsSelected([]);
};

// Kunden-Options für AsyncSelect (tippen => serverseitig filtern)
const loadCustomerOptions = async (inputValue) => {
  const q = (inputValue || '').trim();
  if (q.length < 2) return [];

  try {
    const { data } = await api.get('/customers/search', {
      params: { q, limit: 20 }
    });

    return (data || []).map(c => {
      const title =
        c.company?.trim() ||
        [c.firstName, c.lastName].filter(Boolean).join(' ') ||
        `Kunde #${c.id}`;

      const extras = [
        c.customerNumber ? `Nr: ${c.customerNumber}` : null,
        c.city || null,
        c.email || null
      ].filter(Boolean).join(' · ');

      return {
        value: c.id,
        label: extras ? `${title} — ${extras}` : title
      };
    });
  } catch (e) {
    console.error('loadCustomerOptions failed', e);
    return [];
  }
};




  return (
    <div className="order-list">
      <Helmet>
        <title>Auftragliste</title>
        <meta name="description" content="Auftragliste" />
      </Helmet>
      <h1>Aufträge</h1>

      {/* Button zum Erstellen eines neuen Auftrags */}
      <button 
  onClick={() => setShowNewOrderModal(true)}
  style={{ marginBottom: '20px' }}
>
  Neuen Auftrag erstellen
</button>

      <div style={{ margin: '10px 0 20px', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <button type="button" onClick={selectAllFilteredOrders}>
          Alle gefilterten auswählen
        </button>
        <button type="button" onClick={() => toggleSelectPage(true)}>
          Alle auf dieser Seite auswählen
        </button>
        <button type="button" onClick={() => setSelectedIds([])}>
          Auswahl leeren
        </button>
        <button
          type="button"
          onClick={handleBulkFinalInvoiceMail}
          disabled={bulkProcessing || selectedIds.length === 0}
          style={{
            background: bulkProcessing || selectedIds.length === 0 ? '#9fb8a7' : '#2e8b57',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            padding: '8px 12px',
            cursor: bulkProcessing || selectedIds.length === 0 ? 'not-allowed' : 'pointer'
          }}
        >
          {bulkProcessing ? 'Erstelle + maile...' : 'Schlussrechnungen erstellen + mailen'}
        </button>
        <span style={{ opacity: 0.7 }}>Ausgewählt: {selectedIds.length}</span>
      </div>

      {/* Filterleiste oberhalb der Tabelle */}
<div style={{ marginBottom: '20px'  }}>
  <h3>Filter</h3>
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '10px',
    width: '100%'
  }}>
    <Select
      options={serverFilterOptions.orderNumbers.map(val => ({ value: val, label: val }))}
      placeholder="Auftragsnummer"
      isClearable
      value={filters.orderNumber}
      onChange={(selected) => setFilters({ ...filters, orderNumber: selected })}
    />
    <Select
      options={serverFilterOptions.referenceNumbers.map(val => ({ value: val, label: val }))}
      placeholder="Bestellnummer"
      isClearable
      value={filters.referenceNumber}
      onChange={(selected) => setFilters({ ...filters, referenceNumber: selected })}
    />
    <Select
      options={serverFilterOptions.customers.map(val => ({ value: val, label: val }))}
      placeholder="Kunde"
      isClearable
      value={filters.customer}
      onChange={(selected) => setFilters({ ...filters, customer: selected })}
    />
    <Select
      options={serverFilterOptions.contacts.map(val => ({ value: val, label: val }))}
      placeholder="Besteller"
      isClearable
      value={filters.contact}
      onChange={(selected) => setFilters({ ...filters, contact: selected })}
    />
    <Select
  options={(serverFilterOptions.operationLocations || []).map(val => ({ value: val, label: val }))}
  placeholder="Einsatzort"
  isClearable
  value={filters.operationLocation}
  onChange={(selected) => setFilters({ ...filters, operationLocation: selected })}
/>
    <Select
      styles={{ menu: (provided) => ({ ...provided, zIndex: 11 }) }}
      options={serverFilterOptions.dates.map(val => ({ value: val, label: val }))}
      placeholder="Auftragsdatum"
      isClearable
      value={filters.date}
      onChange={(selected) => setFilters({ ...filters, date: selected })}
    />
    <Select
      options={serverFilterOptions.statuses.map(val => ({ value: val, label: val }))}
      placeholder="Status"
      isClearable
      value={filters.status}
      onChange={(selected) => setFilters({ ...filters, status: selected })}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
  menuPosition="fixed"
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
    menu: (base) => ({ ...base, zIndex: 999999 })
  }}
    />
    <Select
      options={[
        { value: "true", label: "Ja" },
        { value: "false", label: "Nein" },
      ]}
      placeholder="Smart Rental"
      isClearable
      value={filters.smartRental}
      onChange={(selected) => setFilters({ ...filters, smartRental: selected })}
    />
  </div>
</div>

      {/* Tabelle mit Aufträgen */}
      {orders.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={allPageSelected}
                  onChange={(e) => toggleSelectPage(e.target.checked)}
                  aria-label="Alle Aufträge dieser Seite auswählen"
                />
              </th>
              <th>ID</th>
              <th>Auftragsnummer</th>
              <th>Bestellnummer</th>
              <th>Kunde</th>
              <th>Besteller</th>
              <th>Auftragsdatum</th>
              <th>Einsatzort</th>
              <th>Status</th>
              <th>Gesamt netto (€)</th>
              <th>Smart Rental</th>
              <th>Aktionen</th>
              <th>Rechnung</th>
              <th>Ausgabe</th>
            </tr>
          </thead>
          <tbody>
          {orders.map(order => {
            const updatedByValid = !!order.updatedBy;
  // Ermittele alle Rechnungen, die zu diesem Auftrag gehören:
  const invoicesForOrder = invoices.filter(inv => inv.orderId === order.id);
  // NEU: Nur noch offene (nicht gutgeschriebene) Rechnungen:
  const openInvoices = invoicesForOrder.filter(inv => !inv.creditNoteCreated);
  // Gibt es eine offene finale Rechnung?
  const hasFinal = openInvoices.some(inv => inv.invoiceType === "finalInvoice");

  // Status-Bestimmung bleibt wie gehabt, oder du kannst es so auf Basis von offenen Rechnungen machen:
  let state = "none";
  if (openInvoices.length > 0) {
    state = hasFinal ? "final" : "partial";
  }

              return (
                <tr key={order.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(order.id)}
                      onChange={(e) => toggleSelectOrder(order.id, e.target.checked)}
                      aria-label={`Auftrag ${order.orderNumber || order.id} auswählen`}
                    />
                  </td>
                  <td>{order.id}</td>
                  <td>{order.orderNumber}</td>
                  <td>{order.referenceNumber}</td>
                  <td>{order.customer?.company || `${order.customer?.firstName} ${order.customer?.lastName}` || 'Unbekannt'}</td>
                  <td>{order.contact ? `${order.contact.contactFirstName} ${order.contact.contactLastName}` : 'Kein Besteller ausgewählt'}</td>
                  <td>{formatDate(order.date)}</td>
                  <td>{order.operationLocation || 'Nicht angegeben'}</td>
                  <td>{order.status}</td>
                  <td>{order.totalNet?.toFixed(2).replace('.', ',')} €</td>
                  <td>{order.smartRental ? "Ja" : "Nein"}</td>
                  
                  {/* Spalte Aktionen: Bearbeiten & Löschen */}
                  <td>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <button
                        type="button"
                        onClick={() => navigate(`/orders/${order.id}/edit`)}
                        style={{
                          fontSize: '15px',
                          padding: '5px 10px',
                          background: '#007bff',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      >
                        Bearbeiten
                      </button>
                      <button
                        type="button"
                        onClick={() => deleteOrder(order.id)}
                        style={{
                          fontSize: '15px',
                          padding: '5px 10px',
                          background: '#dc3545',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      >
                        Löschen
                      </button>
                      <button
      type="button"
      onClick={() => handleDuplicate(order.id)}
      style={{
        fontSize: '15px',
        padding: '5px 10px',
        background: '#FFA500', // Orange für "Kopie"
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
      }}
    >
      🔁
    </button>
                    </div>
                  </td>
                  
                  {/* Spalte Rechnungen */}
<td>
  {order.status === "completed" ? (
    <span style={{ color: 'green', fontWeight: 'bold' }}>erstellt</span>
  ) : updatedByValid ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
      {(() => {
        // NEU: Alle Rechnungen dieses Auftrags:
        const invoicesForOrder = invoices.filter(inv => inv.orderId === order.id);
        // Nur offene (nicht gutgeschriebene) Rechnungen:
        const openInvoices = invoicesForOrder.filter(inv => !inv.creditNoteCreated);
        // Gibt es eine offene finale Rechnung?
        const hasFinal = openInvoices.some(inv => inv.invoiceType === "finalInvoice");

        // Fall 1: KEINE offenen Rechnungen -> beide Buttons anzeigen
if (openInvoices.length === 0) {
  return (
    <>
      <button
        type="button"
        onClick={() => createInvoice(order.id, "finalInvoice")}
        style={{
          fontSize: '15px',
          padding: '5px 10px',
          background: '#28a745',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        Rechnung
      </button>
      <button
        type="button"
        onClick={() => handleInterim(order.id)}
        style={{
          fontSize: '15px',
          padding: '5px 10px',
          background: '#8e24aa',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        Zwischenabrechnung
      </button>

      {/* ⬇️ NEU: Lexware-Button nur, wenn lexwareEnabled true */}
      {lexwareEnabled && (
        <button
          type="button"
          onClick={() => handleLexwareSync(order.id)}
          style={{
            fontSize: '15px',
            padding: '5px 10px',
            background: '#ff9800', // Orange
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Lexware
        </button>
      )}
    </>
          );
        }

        // Fall 2: Es gibt offene (Teil-)Rechnungen, aber KEINE finale
        if (openInvoices.length > 0 && !hasFinal) {
          return (
            <button
              type="button"
              onClick={() => handleInterim(order.id)}
              style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#8e24aa',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              + Zwischenabrechnung
            </button>
          );
        }

        // Sonst keine Buttons anzeigen
        return null;
      })()}
    </div>
  ) : (
    <div style={{ color: '#aaa', fontStyle: 'italic' }}>
      <span>Rechnung nach Speicherung möglich</span>
    </div>
  )}
</td>



                  
                  {/* Spalte Ausgabe: Ansicht & Mailen */}
                  <td>
          {updatedByValid ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <button
                onClick={() => handleViewPDF(order.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#28a745',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Ansicht
              </button>

              {/* Neuer Button Lieferschein */}
      <button
  onClick={() => openLsModal(order.id, 'ls')}
  style={{ fontSize:'15px', padding:'5px 10px', background:'#6c757d', color:'#fff', border:'none', borderRadius:'5px', cursor:'pointer' }}
>
  LS
</button>

<button
  onClick={() => openLsModal(order.id, 'ls2')}
  style={{ fontSize:'15px', padding:'5px 10px', background:'#343a40', color:'#fff', border:'none', borderRadius:'5px', cursor:'pointer' }}
>
  LS2
</button>
              <button
                onClick={() => sendOrderMail(order.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#17a2b8',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Mailen
              </button>
            </div>
          ) : (
            <div style={{ color: '#aaa', fontStyle: 'italic' }}>
              <span>Ausgabe nach Speicherung möglich</span>
            </div>
          )}
        </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p>Keine Aufträge verfügbar.</p>
      )}
       {/* Pagination */}
       <div style={{ marginTop: '1rem' }}>
        <button
          onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
          disabled={currentPage === 1}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Vorherige
        </button>
        <span style={{ margin: '0 1rem', }}>
          Seite {currentPage} von {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage >= totalPages}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Nächste
        </button>
      </div>

{lsModalOpenFor && (
  <div style={{
    position:'fixed', inset:0, background:'rgba(0,0,0,0.4)',
    display:'flex', alignItems:'center', justifyContent:'center', zIndex: 9999
  }}>
    <div style={{ background:'#fff', padding:'20px', borderRadius:'8px', width:'min(900px, 95vw)' }}>
      <h3>Lieferschein – Positionen wählen</h3>
      <p>Wähle die Artikel, die auf dem Lieferschein erscheinen sollen.</p>

      <div style={{ margin:'10px 0' }}>
        <button onClick={() => setLsSelected(lsOptions)} style={{ marginRight: 8 }}>
          Alle auswählen
        </button>
        <button onClick={() => setLsSelected([])}>
          Auswahl leeren
        </button>
      </div>

      <Select
        options={lsOptions}
        value={lsSelected}
        onChange={(vals) => setLsSelected(vals || [])}
        isMulti
        placeholder="Artikel auswählen…"
        styles={{ menu: (p) => ({ ...p, zIndex: 10000 }) }}
      />

      <div style={{ display:'flex', gap:10, marginTop:20, justifyContent:'flex-end' }}>
        <button onClick={closeLsModal}>Abbrechen</button>
        <button
  onClick={() => {
    const ids = lsSelected.map(o => o.value);
    const perDevice = false; // oder z. B. Checkbox für „pro Gerät“ einbauen
    closeLsModal();
    if (lsModalMode === 'ls2') {
      handleViewDeliveryNote2(lsModalOpenFor, ids, perDevice);
    } else {
      handleViewDeliveryNote(lsModalOpenFor, ids);
    }
  }}
  style={{ background:'#6c757d', color:'#fff', border:'none', padding:'8px 12px', borderRadius:6, cursor:'pointer' }}
>
  PDF erstellen
</button>
      </div>
    </div>
  </div>
)}


{showNewOrderModal && (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
    }}
  >
    <div
      style={{
        background: '#fff',
        padding: 20,
        borderRadius: 8,
        width: 'min(600px, 95vw)',
      }}
    >
      <h3>Neuen Auftrag erstellen</h3>
      <p style={{ marginTop: 4, marginBottom: 12 }}>
        Bitte wähle zuerst den Kunden.
      </p>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>
          Kunde
        </label>
        <AsyncSelect
          cacheOptions
          defaultOptions={false}           // erst bei Eingabe suchen
          loadOptions={loadCustomerOptions}
          value={selectedCustomerOpt}
          onChange={(opt) => setSelectedCustomerOpt(opt)}
          placeholder="Kundenname, Kundennummer, Stadt…"
          isClearable
          // Dropdown über alles rendern:
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          menuPosition="fixed"
          styles={{
            container: (b) => ({ ...b, minWidth: 360 }),
            menuPortal: (b) => ({ ...b, zIndex: 99999 }),
            menu: (b) => ({ ...b, zIndex: 99999 }),
          }}
        />
        {!selectedCustomerOpt && (
          <div style={{ marginTop: 6, fontSize: 12, color: '#a00' }}>
            Bitte einen Kunden auswählen.
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button
          onClick={() => {
            if (isCreatingOrder) return;
            setShowNewOrderModal(false);
            setSelectedCustomerOpt(null);
          }}
          style={{ background: '#eee', color: '#333', padding: '8px 16px', border: 'none', borderRadius: 5 }}
          disabled={isCreatingOrder}
        >
          Abbrechen
        </button>

        <button
          onClick={async () => {
            if (!selectedCustomerOpt) {
              alert('Bitte zuerst einen Kunden wählen.');
              return;
            }
            try {
              setIsCreatingOrder(true);
              await createDraftOrder(selectedCustomerOpt.value);
              setShowNewOrderModal(false);
              setSelectedCustomerOpt(null);
            } finally {
              setIsCreatingOrder(false);
            }
          }}
          disabled={isCreatingOrder || !selectedCustomerOpt}
          style={{
            background: '#2eae4a',
            color: '#fff',
            padding: '8px 16px',
            border: 'none',
            borderRadius: 5,
            opacity: (isCreatingOrder || !selectedCustomerOpt) ? 0.7 : 1,
            cursor: (isCreatingOrder || !selectedCustomerOpt) ? 'not-allowed' : 'pointer',
          }}
        >
          {isCreatingOrder ? 'Lege an…' : 'Auftrag anlegen'}
        </button>
      </div>
    </div>
  </div>
)}

     
    </div>
  );
};

export default OrderList;
